export enum PagePermissionLevel {
  Edit = 'Edit',
  ReadOnly = 'ReadOnly',
  NoAccess = 'NoAccess'
}
